import { lazy } from 'react';

export const cmsModalComponentByType = {
  SUBSCRIBED_TO_SUBSITE: lazy(() =>
    import('#/modules/cms/components/SubscribedToSubsiteModal/SubscribedToSubsiteModal').then(
      (module) => ({ default: module.SubscribedToSubsiteModal }),
    ),
  ),
  JOIN_MOVEMENT: lazy(() =>
    import('#/modules/cms/components/JoinMovementModal/JoinMovementModal').then(
      (module) => ({ default: module.JoinMovementModal }),
    ),
  ),
} as const satisfies Record<string, unknown>;
